import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { io } from "socket.io-client";
import Restaurant from "./Component/Restaurant";
import Restlist from "./Component/restlist";
import Quiz from "./Component/Quiz";
import Navbar from "./Component/Navbar";
import Sidebar from "./Component/Sidebar";
import HomePage from "./Component/HomePage";
import RegisterForm from "./Component/RegisterForm";
import Settings from "./Component/Settings";
import ResetPassword from "./Component/ResetPassword";
import Friends from "./Component/Friends";
import Groups from "./Component/Groups";
import PromiseComponent from "./Component/PromiseComponent";
import Messaging from "./Component/message";
import Notification from "./Component/Notification";
import Recent from "./Component/Recent";
import About from "./Component/About";
import Profile from "./Component/Profile";
import Logout from "./Component/logout";
import { Fariha } from "./Component/Fariha";
import { Sarah } from "./Component/Sarah";
import { Marcus } from "./Component/Marcus";
import { Lorenzo } from "./Component/Lorenzo";
import { Haoyang } from "./Component/Haoyang";
import LoginForm from "./Component/LoginForm";
import Following from "./Component/Following";
import Followers from "./Component/Followers";
import Posts from "./Component/Posts";
import { Self } from "./Component/Self";
import Submit from "./Component/Submit";
import Modal from "./Component/Modal";
import StyleGuide from "./Component/StyleGuide";
import OtherProfile from "./Component/OtherProfile";
import DishPage from "./Component/DishPage";
import Navpage from "./Component/Navpage";
import PostForm from "./Component/PostForm";
import PostView from "./Component/PostView";
import PostViewSingle from "./Component/PostViewSingle";
import EditPost from "./Component/PostEditFeature";
import PostEDit from "./Component/PostEditFeature";
import PostPlaceholder from "./Component/PostPlaceholder";
import DeleteAccount from "./Component/DeleteAccount";
import OtherFollowing from "./Component/OtherFollowing";
import OtherFollowers from "./Component/OtherFollowers";
import "./Sarah.css";
import BlockedUsers from "./Component/BlockedUsers";


// Initialize the socket connection
const socket = io(process.env.REACT_APP_API_PATH_SOCKET, {
  path: '/hci/api/realtime-socket/socket.io',
  query: {
    tenantID: "indecisive"
  }
})
export { socket }


// Layout component that wraps common UI elements
const Layout = ({ children, toggleModal, logout }) => {
 return (
   <div className="app-container">
     <Navbar toggleModal={toggleModal} logout={logout} />
     <div className="main-layout">
       <Sidebar />
       <div className="content" id="content">{children}</div>
     </div>
   </div>
 );
};
const MobileLayout = ({ children, toggleModal, logout }) => {
 return (
   <div className="app-container">
     <Navbar toggleModal={toggleModal} logout={logout} />
     <div className="main-layout">
       <div className="content">{children}</div>
     </div>
   </div>
 );
};
const MobileLayoutSarah = ({ children, toggleModal, logout }) => {
 return (
   <div className="app-container">
     <Navbar toggleModal={toggleModal} logout={logout} />
     <div className="main-layout">
     <Sidebar />
       <div className="Sarahcontent">{children}</div>
     </div>
   </div>
 );
};
const HomeLayout = ({ children, toggleModal, logout }) => {
  return (
    <div className="app-container">
      
      <Navbar toggleModal={toggleModal} logout={logout} />
      <div className="main-layout">
      <Sidebar />
        <div className="home-content">{children}</div>
      </div>
    </div>
  );
};

// Protected route component
const ProtectedRoute = ({ children, redirectPath = "/login", redirectMessage = "Please log in to continue" }) => {
  const isAuthenticated = sessionStorage.getItem("token") && sessionStorage.getItem("user");
  
  if (!isAuthenticated) {
    // Get the current path to store in redirect state
    const currentPath = window.location.pathname;
    return (
      <Navigate 
        to={redirectPath} 
        replace 
        state={{ from: currentPath, message: redirectMessage }} 
      />
    );
  }

  return children;
};

function App() {
 const [loggedIn, setLoggedIn] = useState(false);
 const [openModal, setOpenModal] = useState(false);
 const [refreshPosts, setRefreshPosts] = useState(true);




  const logout = (e) => {
    e.preventDefault();
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setLoggedIn(false);
    window.location.reload();
  };


  const toggleModal = (e) => {
    e.preventDefault();
    setOpenModal((prev) => !prev);
  };


 const doRefreshPosts = () => {
   console.log("CALLING DOREFRESHPOSTS IN APP.JSX");
   setRefreshPosts(true);
 };


useEffect(() => {
  socket.on("connect", () => {
    console.log("Connected to HCI socket server")
  })
}, [])

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        {/* You might want to move the head tag to the public/index.html file */}
        <Routes>
          <Route
            path="/"
            element={
              <HomeLayout toggleModal={toggleModal} logout={logout}>
                <HomePage
                  setLoggedIn={setLoggedIn}
                  doRefreshPosts={doRefreshPosts}
                  appRefresh={refreshPosts}
                />
              </HomeLayout>
            }
          />
       
          <Route
            path="/login"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <LoginForm setLoggedIn={setLoggedIn} />
              </Layout>
            }
          />
          <Route
            path="/style-guide"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
              <StyleGuide/>
              </Layout>
            }
          />
          <Route
            path="/signup"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <RegisterForm setLoggedIn={setLoggedIn} />
              </Layout>
            }
          />
          <Route
            path="/reset-password"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <ResetPassword />
              </Layout>
            }
          />
          <Route
            path="/settings"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Settings />
              </Layout>
            }
          />
          <Route
            path="/username-submit"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Submit />
              </Layout>
            }
          />
          <Route
            path="/password-submit"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Submit />
              </Layout>
            }
          />
          <Route
            path="/email-submit"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Submit />
              </Layout>
            }
          />
          <Route
            path="/friends"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Friends />
              </Layout>
            }
          />
          <Route
            path="/groups"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Groups />
              </Layout>
            }
          />
          <Route
            path="/promise"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <PromiseComponent />
              </Layout>
            }
          />
          <Route
            path="/notifications"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Notification />
              </Layout>
            }
          />
          <Route
            path="/recent"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Recent />
              </Layout>
            }
          />

          <Route
            path="/blockedUsers"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <BlockedUsers />
              </Layout>
            }
          >
            
          </Route>

          <Route
            path="/about"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <About />
              </Layout>
            }
          />
          <Route
            path="/about/fariha"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Fariha />
              </Layout>
            }
          />
          <Route
            path="/about/sarah"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Sarah />
              </Layout>
            }
          />
          <Route
            path="/about/marcus"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Marcus />
              </Layout>
            }
          />
          <Route
            path="/about/lorenzo"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Lorenzo />
              </Layout>
            }
          />
          <Route
            path="/about/haoyang"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Haoyang />
              </Layout>
            }
          />
          <Route
            path="/profile"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Profile />
              </Layout>
            }
          />
          <Route
            path="/review"
            element={
              <ProtectedRoute redirectMessage="Please log in to add a review">
                <MobileLayoutSarah toggleModal={toggleModal} logout={logout}>
                  <PostForm refresh={console.log} loadPosts={console.log} />
                </MobileLayoutSarah>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviewPost/:id"
            element={
              <MobileLayoutSarah toggleModal={toggleModal} logout={logout}>
                <PostViewSingle />
              </MobileLayoutSarah>
            }
          />
          <Route
            path="/self"
            element={

              <div className="app-container">
              <Navbar toggleModal={toggleModal} logout={logout}/>
              <div className="main-layout">
                <Sidebar />
                <div className="self-content"><Self /></div>
              </div>
            </div>} />
            <Route
              path="/user/:otherUserId"
              element={
                <div className="app-container">
                  <Navbar toggleModal={toggleModal} logout={logout}/>
                  <div className="main-layout">
                    <Sidebar />
                    <div className="self-content"><OtherProfile /></div>
                  </div>
                </div>
              }
            />

          {/* --- ADDED ROUTE FOR DISH REVIEW FORM --- */}
          <Route
            path="/dish/:dishId/new-post"
            element={
              <ProtectedRoute redirectMessage="Please log in to add a review">
                <Layout toggleModal={toggleModal} logout={logout}>
                  {/* Using the original props as provided */}
                  <PostForm refresh={console.log} loadPosts={console.log} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* --- END ADDED ROUTE --- */}

          <Route
            path="/dish/:dishId"
            element={
              <div className="app-container">
                <Navbar toggleModal={toggleModal} logout={logout}/>
                <div className="main-layout">
                  <Sidebar />
                  {/* Keeping original class */}
                  <div className="self-content"><DishPage /></div>
                </div>
              </div>
            }
          />
          <Route
            path="/followers"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Followers />
              </Layout>
            }
          />

          <Route
            path="/followers/:otherUserId"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <OtherFollowers />
              </Layout>
            }
          />

          <Route
            path="/following"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Following />
              </Layout>
            }
          />

          <Route
            path="/following/:otherUserId"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <OtherFollowing />
              </Layout>
            }
          />
          <Route
            path="/post-placeholder"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <PostPlaceholder />
              </Layout>
            }
          />
          <Route
            path="/quiz"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <Quiz setLoggedIn={setLoggedIn}
                  doRefreshPosts={doRefreshPosts}
                  appRefresh={refreshPosts}/>
              </Layout>
            }
          />
          <Route
            path="/delete-account"
            element={
              <Layout toggleModal={toggleModal} logout={logout}>
                <DeleteAccount />
              </Layout>
            }
          />
        <Route
          path="/restaurant/:id"
          element={
            <Layout toggleModal={toggleModal} logout={logout}>
            <Restaurant />
          </Layout>
        }
        />
        <Route
          path="/reviewPost/edit/:id"
          element={
            <MobileLayoutSarah toggleModal={toggleModal} logout={logout}>
              <EditPost />
            </MobileLayoutSarah>
            }
        />
        <Route
          path="/logout"
          element={ <Logout />}
        />
        <Route
          path="/restlist"
          element={
            <Layout toggleModal={toggleModal} logout={logout}>
              <Restlist />
            </Layout>
          }
        />
        <Route
          path="/message"
          element={
            <Layout toggleModal={toggleModal} logout={logout}>
              <Messaging />
            </Layout>
          }
        />
        </Routes>
        <Modal show={openModal} onClose={toggleModal}>
          This is a modal dialog!
        </Modal>
      </div>
    </Router>
  );
}


export default App;